(() => {
  'use strict';

  // Judge.me is loaded asynchronously. Inject the override once, with a few
  // bounded retries, instead of observing the whole document continuously.
  // A document-wide MutationObserver can fight Judge.me's own Vue rendering
  // loop and make the product page feel frozen.
  const styleId = 'ivellora-review-runtime-styles';
  const css = `
    #judgeme_product_reviews.jdgm-widget-revamp,
    #judgeme_product_reviews .jm-review-widget {
      --jm-review-widget-star-and-histogram-color: #805263 !important;
      --jm-review-widget-button-color: #764858 !important;
      --jm-review-widget-button-text-color: #ffffff !important;
      --jm-widget-primary-color: #764858 !important;
      --jm-review-widget-text-color: #332b29 !important;
      --jm-review-widget-lighter-text-color: #81746f !important;
    }
    #judgeme_product_reviews .jm-review-widget__header.jm-review-widget-minimal-header {
      margin: 0 0 24px !important;
      padding: 25px 28px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #f8f3ef !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header > .jm-cluster {
      display: grid !important;
      grid-template-columns: minmax(260px,1fr) auto !important;
      align-items: center !important;
      gap: 28px !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header__title {
      margin: 0 !important;
      color: #352a27 !important;
      font-family: var(--font-heading--family, "Marcellus", Georgia, serif) !important;
      font-size: 25px !important;
      font-weight: 400 !important;
      letter-spacing: .018em !important;
    }
    #judgeme_product_reviews .jm-average-rating-display {
      display: inline-flex !important;
      align-items: baseline !important;
      gap: 9px !important;
      margin-top: 10px !important;
    }
    #judgeme_product_reviews .jm-average-rating-display .jm-text:first-child {
      color: #352a27 !important;
      font-family: var(--font-body--family, Arial, sans-serif) !important;
      font-size: 23px !important;
      font-weight: 600 !important;
      letter-spacing: -.02em !important;
      line-height: 1 !important;
    }
    #judgeme_product_reviews .jm-average-rating-display .jm-text:last-child {
      color: #8b7d77 !important;
      font-size: 11px !important;
      line-height: 1 !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      justify-content: flex-end !important;
      gap: 9px !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button,
    #judgeme_product_reviews button[data-testid="write-review-button"] {
      min-width: 170px !important;
      min-height: 40px !important;
      padding: 0 21px !important;
      border: 1px solid #764858 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #764858 !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      letter-spacing: .12em !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button:hover,
    #judgeme_product_reviews button[data-testid="write-review-button"]:hover {
      background: #764858 !important;
      color: #fff !important;
    }
    #judgeme_product_reviews .jm-review-widget-minimal-header__filters {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
    }
    #judgeme_product_reviews .jm-custom-answer-filter {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: auto !important;
      min-width: 84px !important;
      min-height: 36px !important;
      padding: 0 12px !important;
      border: 1px solid #d8cbc5 !important;
      border-radius: 2px !important;
      background: #fff !important;
      color: #5d504c !important;
    }
    #judgeme_product_reviews .jm-custom-answer-filter__text {
      display: inline !important;
      visibility: visible !important;
      color: #5d504c !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      letter-spacing: .08em !important;
      text-transform: uppercase !important;
    }
    #judgeme_product_reviews .jm-sort-filter {
      display: inline-flex !important;
      align-items: center !important;
      position: relative !important;
    }
    #judgeme_product_reviews .jm-sort-filter__icon--sort { display: none !important; }
    #judgeme_product_reviews .jm-sort-filter__select,
    #judgeme_product_reviews select.jdgm-sort-dropdown {
      display: block !important;
      width: 130px !important;
      min-width: 130px !important;
      max-width: 130px !important;
      min-height: 36px !important;
      padding: 0 28px 0 12px !important;
      border: 1px solid #d8cbc5 !important;
      border-radius: 2px !important;
      background: #fff !important;
      color: #5d504c !important;
      font-size: 11px !important;
      opacity: 1 !important;
      visibility: visible !important;
      appearance: none !important;
      -webkit-appearance: none !important;
    }
    #judgeme_product_reviews .ivellora-sort-label {
      display: inline-block !important;
      margin-right: 7px !important;
      color: #81746f !important;
      font-size: 11px !important;
      white-space: nowrap !important;
    }
    #judgeme_product_reviews .jm-star-rating,
    #judgeme_product_reviews .jm-star-rating__font-icon,
    #judgeme_product_reviews .jdgm-star,
    #judgeme_product_reviews [class*="star"] {
      color: #805263 !important;
      fill: #805263 !important;
      stroke: #805263 !important;
    }
    #judgeme_product_reviews .jm-review-widget__body .jdgm-review-list { gap: 0 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item { margin: 0 !important; padding: 0 !important; border: 0 !important; background: transparent !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item > .jm-stack { display: block !important; padding: 30px 0 32px !important; border-bottom: 1px solid #e5dad5 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item__body { display: block !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content { display: grid !important; grid-template-columns: 166px minmax(0,1fr) !important; grid-template-rows: auto auto !important; column-gap: 42px !important; row-gap: 5px !important; width: 100% !important; padding: 0 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content > .jm-cluster:first-child { display: block !important; grid-column: 2 !important; grid-row: 1 !important; margin: 0 0 10px !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content > .jm-reviewer-info { display: flex !important; grid-column: 1 !important; grid-row: 1 / span 2 !important; align-items: flex-start !important; margin: 0 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-reviewer-avatar { flex: 0 0 34px !important; width: 34px !important; height: 34px !important; border: 1px solid #e5d8d2 !important; border-radius: 50% !important; background: #fbf5f1 !important; color: #805263 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-reviewer-avatar__initial { color: #805263 !important; font-size: 12px !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-reviewer-info__details { gap: 2px !important; margin-left: 10px !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-reviewer-info__name { color: #3b302d !important; font-size: 13px !important; font-weight: 600 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-reviewer-info__details > .jm-cluster:last-child { color: #8b7d77 !important; font-size: 11px !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-content { display: block !important; grid-column: 2 !important; grid-row: 2 !important; margin: 0 !important; padding: 0 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-content__body,
    #judgeme_product_reviews .jm-review-widget__body .jm-review-content__body p { max-width: 680px !important; margin: 0 !important; color: #615652 !important; font-size: 14px !important; line-height: 1.75 !important; }
    #judgeme_product_reviews .jm-review-widget__body .jm-review-content__expand-button { margin: 8px 0 0 !important; padding: 0 !important; color: #805263 !important; background: transparent !important; font-size: 11px !important; letter-spacing: .08em !important; text-transform: uppercase !important; }
    @media (max-width: 900px) {
      #judgeme_product_reviews .jm-review-widget-minimal-header > .jm-cluster { grid-template-columns: 1fr !important; gap: 18px !important; }
      #judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters { justify-content: flex-start !important; flex-wrap: wrap !important; }
    }
    @media (max-width: 749px) {
      #judgeme_product_reviews .jm-review-widget__header.jm-review-widget-minimal-header { padding: 22px 18px !important; }
      #judgeme_product_reviews .jm-review-widget-minimal-header > .jm-cluster { display: block !important; }
      #judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters { margin-top: 16px !important; }
      #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons,
      #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons > .jm-stack,
      #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button { width: 100% !important; }
      #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content { display: block !important; }
      #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content > .jm-reviewer-info,
      #judgeme_product_reviews .jm-review-widget__body .jm-review-item__content > .jm-cluster:first-child,
      #judgeme_product_reviews .jm-review-widget__body .jm-review-content { margin-bottom: 10px !important; }
      #judgeme_product_reviews .jm-pagination,
      #judgeme_product_reviews .jm-pagination-container,
      #judgeme_product_reviews .jm-review-widget__pagination,
      #judgeme_product_reviews .jm-pagination-controls,
      #judgeme_product_reviews .jdgm-paginate { display: flex !important; flex-flow: row nowrap !important; align-items: center !important; justify-content: center !important; gap: 7px !important; width: 100% !important; margin: 24px auto 8px !important; padding: 0 !important; }
      #judgeme_product_reviews .jm-pagination-controls > .jm-cluster { display: flex !important; flex-flow: row nowrap !important; align-items: center !important; justify-content: center !important; gap: 7px !important; width: 100% !important; }
      #judgeme_product_reviews .jm-pagination button,
      #judgeme_product_reviews .jm-pagination a,
      #judgeme_product_reviews .jm-pagination-container button,
      #judgeme_product_reviews .jm-pagination-container a,
      #judgeme_product_reviews .jm-review-widget__pagination button,
      #judgeme_product_reviews .jm-review-widget__pagination a,
      #judgeme_product_reviews .jm-pagination-controls .jm-pagination-controls__button,
      #judgeme_product_reviews .jdgm-paginate__page { display: inline-flex !important; flex: 0 0 38px !important; align-items: center !important; justify-content: center !important; width: 38px !important; min-width: 38px !important; max-width: 38px !important; height: 38px !important; min-height: 38px !important; margin: 0 !important; padding: 0 !important; border: 1px solid #ded2ce !important; border-radius: 2px !important; background: #fff !important; color: #5f5050 !important; font-size: 13px !important; font-weight: 500 !important; line-height: 1 !important; text-decoration: none !important; }
      #judgeme_product_reviews .jm-pagination [aria-current="page"],
      #judgeme_product_reviews .jm-pagination-container [aria-current="page"],
      #judgeme_product_reviews .jm-review-widget__pagination [aria-current="page"],
      #judgeme_product_reviews .jm-pagination-controls__button--active,
      #judgeme_product_reviews .jm-pagination .is-active,
      #judgeme_product_reviews .jm-pagination-container .is-active,
      #judgeme_product_reviews .jm-review-widget__pagination .is-active,
      #judgeme_product_reviews .jdgm-paginate__page.jdgm-curt { border-color: #764858 !important; background: #764858 !important; color: #fff !important; }
      #judgeme_product_reviews .jm-pagination button:disabled,
      #judgeme_product_reviews .jm-pagination-container button:disabled,
      #judgeme_product_reviews .jm-review-widget__pagination button:disabled,
      #judgeme_product_reviews .jm-pagination-controls__button:disabled,
      #judgeme_product_reviews .jm-pagination-controls__button--disabled,
      #judgeme_product_reviews .jdgm-paginate__page.jdgm-disabled { border-color: #eadfdb !important; background: #f7f2ef !important; color: #b8aaa5 !important; opacity: 1 !important; }
    }
  `;

  function enhanceControls() {
    const root = document.getElementById('judgeme_product_reviews');
    if (!root) return;

    const filter = root.querySelector('.jm-custom-answer-filter');
    const filterText = filter?.querySelector('.jm-custom-answer-filter__text');
    if (filterText) {
      filterText.textContent = 'Filters';
      filterText.style.display = 'inline';
      filterText.style.visibility = 'visible';
    }

    const select = root.querySelector('.jm-sort-filter select');
    const sort = root.querySelector('.jm-sort-filter');
    if (sort && select) {
      select.setAttribute('aria-label', 'Sort by');
      if (!sort.querySelector('.ivellora-sort-label')) {
        const label = document.createElement('span');
        label.className = 'ivellora-sort-label';
        label.textContent = 'Sort by';
        label.setAttribute('aria-hidden', 'true');
        if (select.parentElement === sort) {
          sort.insertBefore(label, select);
        } else {
          sort.prepend(label);
        }
      }
    }

    const average = root.querySelector('.jm-average-rating-display');
    if (average && !average.querySelector('.ivellora-summary-stars')) {
      const scoreNode = average.querySelector('.jm-text');
      const score = Math.max(0, Math.min(5, parseFloat(scoreNode?.textContent || '0') || 0));
      const stars = document.createElement('span');
      stars.className = 'ivellora-summary-stars';
      stars.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < 5; index += 1) {
        const star = document.createElement('span');
        star.className = 'ivellora-summary-star';
        star.textContent = '★';
        star.style.color = '#805263';
        star.style.opacity = index < score ? '1' : '0.25';
        stars.appendChild(star);
      }
      average.prepend(stars);
    }
  }

  function injectStyle() {
    if (!document.head || document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.type = 'text/css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function refresh() {
    injectStyle();
    enhanceControls();
  }

  refresh();
  // Judge.me may replace its root after the initial paint; retries are bounded
  // and do not observe or mutate the whole page.
  [350, 1000, 2200].forEach((delay) => window.setTimeout(refresh, delay));
})();
